module.exports = __webpack_public_path__ + "static/media/logo.bc33ce15.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 66
// module chunks = 0